var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"main-container"},[_c('h1',{staticClass:"mb-5"},[_vm._v(_vm._s(_vm.$t("unauthorized.Title")))]),_c('p',[_vm._v(_vm._s(_vm.$t("Unauthorized.description")))]),_c('a',{attrs:{"href":_vm.$router.resolve({ name: 'Bop' }).href}},[_vm._v(_vm._s(_vm.$t("Unauthorized.goToHomePage")))])])
}
var staticRenderFns = []

export { render, staticRenderFns }